import { render, staticRenderFns } from "./PromoActionSelect.vue?vue&type=template&id=d7960a44&scoped=true&"
import script from "./PromoActionSelect.vue?vue&type=script&lang=js&"
export * from "./PromoActionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7960a44",
  null
  
)

export default component.exports